<template>
  <div>
    <b-modal
      id="modalCrosswalk"
      title="รายงานความผิดปกติบนท้องถนน"
      size="xl"
      ok-only
    >
      <b-row>
        <b-col
          lg="4"
          md="4"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label>ค้นหา</label>
          <b-input-group
            size="sm"
            style="padding-left:14px;"
          >
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="ป้อนคำค้นหา"
              label-cols-sm="12"
              label-cols-md="2"
              label-cols-lg="2"
              style=" background-color:rgba(0,0,0, 0.6);"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                ล้าง
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12">
          <b-table
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(row_num)="data">
              {{ data.index + 1 }}
            </template>
            <!-- <template #cell(EventType)="data">
              {{ EventType[0][data.value] }}
            </template> -->
            <template #cell(FilePath)="data">
              <b-img
                :src="data.item.FilePath"
                width="150px"
                fluid
                @click="showImg(data.item.FilePath)"
              />
            </template>
          </b-table>
        </b-col>
        <b-col
          cols="12"
        >
          <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
            <!-- page length -->
            <b-form-group
              label="Per Page"
              label-cols="6"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
              />
            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-col>
      </b-row>
      <!-- <download-excel
      class="btn btn-default"
      :data="items"
      :fields="fields.key"
      name="filename.xls"
    >

      Download

    </download-excel> -->
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BPagination, BInputGroup, BInputGroupAppend, BFormInput, BButton,
  BFormGroup, BFormSelect, BCardBody, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
// import Vue from 'vue'
// import JsonExcel from 'vue-json-excel'

// Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
    BFormGroup,
    BFormSelect,
    BCardBody,
    // BLink,
    BImg,
    // BBadge,
  },
  data() {
    return {
      fields: [
        {
          key: 'row_num',
          label: 'ลำดับ',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'DATE_TIME',
          label: 'วันที่',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'EventType',
          label: 'เหตุการณ์',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'CAMID',
          label: 'กล้องที่',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'FilePath',
          label: 'ภาพเหตุการณ์',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      // status: [{
      //   Online: 'Online', Offline: 'Offline',
      // },
      // {
      //   Online: 'success', Offline: 'danger',
      // }],

      // เลือกโชว์เหตุการณ์
      // EventType: [{
      //   AI_Ticker: 'กดอัตโนมัติ', Human_Ticker: 'คนกดปุ่ม',
      // }],

      // json_data: [
      //   {
      //     name: 'Tony Peña',
      //     city: 'New York',
      //     country: 'United States',
      //     birthdate: '1978-03-15',
      //     phone: {
      //       mobile: '1-541-754-3010',
      //       landline: '(541) 754-3010',
      //     },
      //   },
      //   {
      //     name: 'Thessaloniki',
      //     city: 'Athens',
      //     country: 'Greece',
      //     birthdate: '1987-11-23',
      //     phone: {
      //       mobile: '+1 855 275 5071',
      //       landline: '(2741) 2621-244',
      //     },
      //   },
      // ],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      return this.fieldsSpeaker
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getTableCrossWalk()
    this.interval = setInterval(() => {
      this.getTableCrossWalk()
    }, 300000)
  },
  methods: {
    getTableCrossWalk() {
      axios
        .post('/tableCrossWalkDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.camid = response.data.CAMID
        })
        .catch(error => {
          console.log(error)
        })
    },
    showImg(img) {
      this.$swal({
        imageUrl: img,
        imageAlt: 'Custom image',
        width: 800,
        background: 'hsla(0, 100%, 100%, 0)',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
